import React, { useEffect, useState } from 'react'
import Swal from "sweetalert2"

import '../../styles/pacientesPendientes.css'

/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, usersCollection } from '../../firebase/config';

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaObject } from '../../objects/unidadHospitalaria';
//Importar las funciones relacionadas al objeto User
import { createUser } from '../../objects/user';

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from './encabezadoSeccion';
//Componente que muestra al usuario que se esta procesando la información del servicio
import Loader from './loader';
//Componente que indica al usuario que no se obtuvo información con sus parámetros de búsqueda
import SinResultados from './sinResultados';
//Componente que muestra la información de un usuario del sistema
import Usuario from './usuarioCard';

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { compararInformación, descrifrar, quitarAcentos } from '../../utils/functions';

/**
 * Componente que contiene el listado de usuarios disponibles
 * @param {Object} param0 Recibe la información de sesión
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const Usuarios = ({uhList,userLevel,nomHospital,setIsReadOnly,isReadOnly}) => {

    //Estado que indica si se hay usuarios que mostrar
    const [hayResultados, setHayResultados] = useState(false)
    //Estado que indica que se esta solicitando información al servicio
    const [isLoader,setIsLoader] = useState(false)
    //Estado que indica si se muestra la opción para limpiar la búsqueda
    const [seMuestra,setSeMuestra] = useState(true)
    //Estado que almacena los resultados de la búsqueda de usuarios según el parámetros requerido por el usuario
    const [usersAmostrarList,setUsersAmostrarList] = useState([])
    //Estado que almacena los usuarios obtenidos desde la base de datos en una lista
    const [usersList,setUsersList] = useState([])
    //Estado que almacena el parametro de búsqueda para el muestreo de usuarios (si se encuentra vacio se consideran toda la lista de pacientes)
    const [valorBusqueda,setValorBusqueda] = useState("")
    const [uhSelected,setUhSelectd] = useState("General")
    const [isMostrarUnidad, setIsMostrarUnidad] = useState(false)

    useEffect(()=>{
        setIsLoader(true)
        pacientesStore.collection(usersCollection)
        .onSnapshot(snap => {
            const users = []
            snap.forEach(doc => {
                users.push({ id: doc.id, ...doc.data() })
            })
            console.log(users)
            setIsLoader(false)
            setUsersList(users)
        },(error)=>{
            setIsLoader(false)
            setUsersList([])
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error,
              })
        })
    },[])

    useEffect(()=>{
        if(valorBusqueda){
            setSeMuestra(true)
        }
        else{
            setSeMuestra(false)
        }
    },[valorBusqueda])


    useEffect(()=>{
        if(userLevel === "credencializacion" || userLevel === "lectura"){
            setIsMostrarUnidad(false)
            if(userLevel === "lectura"){
                setIsReadOnly(true)
            }
            else{
                setIsReadOnly(false)
            }
        }
        else{
            setIsMostrarUnidad(true)
            setIsReadOnly(false)
        }
    },[userLevel,setIsReadOnly])

    useEffect(()=>{
        if(usersList.length > 0){//Verificar si existen usuarios
            if(valorBusqueda){//Se desea realizar búsqueda de un usuario específico
                let resultadoBusqueda = []
                usersList.forEach(
                    user =>{
                        let isAutorized = false
                        if(user.Systems){
                            for(let j=0;j<user.Systems.length;j++){
                                if(user.Systems[j].id === "5" && user.Systems[j].active){
                                    isAutorized = true
                                }
                            }
                        }
                        else{
                            isAutorized = false
                        }

                        if(user.Permiso && user.Nombre && user.UnidadHospitalaria && isAutorized){
                            if(user.Permiso.toUpperCase().includes(valorBusqueda.toUpperCase())
                                || quitarAcentos(user.Nombre.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))
                                || user.UnidadHospitalaria.hospital.toUpperCase().includes(valorBusqueda.toUpperCase())){
                                    if(uhSelected === 'General'){
                                        if(user.Nombre !== "Desarrollo"){
                                            resultadoBusqueda.push(user)
                                        }
                                    }
                                    else{
                                        if(uhSelected === user.UnidadHospitalaria.hospital && user.Nombre !== "Desarrollo"){
                                            resultadoBusqueda.push(user)
                                        }
                                    }
                                }
                        }
                    }
                )

                if(resultadoBusqueda.length > 0){//Se encontraron resultados a la búsqueda deseada
                    setHayResultados(true)
                    //Ordenar los resultados por un valor específico
                    resultadoBusqueda.sort(compararInformación('Nombre'))
                }
                else{//La búsqueda no obtuvo ningún paciente como resultado
                    setHayResultados(false)
                }
                setUsersAmostrarList(resultadoBusqueda)
            }
            else{//Se muestran todos los usuarios disponibles
                usersList.sort(compararInformación('Nombre'))
                let usuariosValidos = 0
                let usuariosCredencialesList = []
                usersList.forEach(
                    user => {
                        let isAutorized = false
                        if(user.Systems){
                            for(let j=0;j<user.Systems.length;j++){
                                if(user.Systems[j].id === "5" && user.Systems[j].active){
                                    isAutorized = true
                                }
                            }
                        }
                        else{
                            isAutorized = false
                        }

                        if(isAutorized){
                            if(uhSelected === 'General'){
                                if(user.Nombre !== "Desarrollo"){
                                    usuariosValidos = usuariosValidos + 1
                                    usuariosCredencialesList.push(user)
                                }
                            }
                            else{
                                if(uhSelected === user.UnidadHospitalaria.hospital && user.Nombre !== "Desarrollo"){
                                    usuariosValidos = usuariosValidos + 1
                                    usuariosCredencialesList.push(user)
                                }
                            }
                        }
                    }
                )

                if(usuariosValidos > 0){//Se verifica si hay usuario disponles para vista
                    //Se asigna la lista de usuarios disponibles para vista
                    setUsersAmostrarList(usuariosCredencialesList)
                    setHayResultados(true)
                }
                else{//Se muestra la tarjeta de sin resultados
                    setUsersAmostrarList([])
                    setHayResultados(false)
                }
            }
        }
        else{//No hay usuarios por mostrar
            setUsersAmostrarList([])
            setHayResultados(false)
        }
    },[usersList,valorBusqueda,uhList,nomHospital,userLevel,uhSelected])

    /**
     * Función que atrapa el evento para agregar un usuario
     * @returns Devuelve el estado del objeto
     */
    const handleAgregar = () => (event) => {
        event.preventDefault()
        let uhOpciones = ""
        let levelOpciones = ""
        if(userLevel === "superuser"){//Se verifica si el usuario logeado tiene acceso total
            //Se muestran en el select de unidades hospitalarias todas las unidades disponibles
            uhOpciones += "<option value="+0+">-- Seleccione la unidad hospitalaria --</option>"
            uhList.forEach(uh => {
                uhOpciones+="<option value="+uh.id+">"+uh.hospital+"</option>"
            })
            //Se muestran en el select de permisos los niveles SuperUser, Administrador y Normal
            levelOpciones += "<option value="+0+">-- Seleccione el nivel de permiso --</option>"
            levelOpciones += "<option value=superuser>SuperUser</option>"
            levelOpciones += "<option value=lectura>Solo lectura</option>"
            levelOpciones += "<option value=credencializacion>Credencialización</option>"
        }else{//Usuario con acceso de tipo administrador
            //Se muestra en el select de unidad hospitalaria solo a la que pertenene el usuario logeado
            uhList.forEach(uh => {
                if(descrifrar(nomHospital).toString() === uh.id){
                    uhOpciones+="<option value="+uh.id+">"+uh.hospital+"</option>"
                }
            })
            //Se muestra en el select de permisos los niveles Administrador y Normal
            levelOpciones += "<option value="+0+">-- Seleccione el nivel de permiso --</option>"
            levelOpciones += "<option value=lectura>Solo lectura</option>"
            levelOpciones += "<option value=credencializacion>Credencialización</option>"
        }

        Swal.fire({
            customClass:'modalRegistro',
            html:`<div class="form_wrapper">
                <div class="form_container">
                    <div class="row clearfix">
                        <div class="">
                            <form autocomplete="off" method="post">
                                <h2 class="modalTitle">Usuario Nuevo</h2>
                                <br />
                                <div class="input_field">
                                    <input type="text" name="inputNombre" id="inputNombre" placeholder="Ingrese el nombre del usuario" 
                                    required  class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')"/>
                                </div>
                                <div class="input_field select_option">
                                    <select id="selectNivel">
                                        `+levelOpciones+`
                                    </select>
                                    <div class="select_arrow"></div>
                                </div>
                                <div class="input_field select_option">
                                    <select id="selectUH">
                                        `+uhOpciones+`
                                    </select>
                                    <div class="select_arrow"></div>
                                </div>
                                <div class="input_field">
                                    <input type="text" name="inputNick" id="inputNick" placeholder="Ingrese el usuario de acceso" 
                                    required class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[' ']/g,'')"/>
                                </div>
                                <div class="input_field">
                                    <input type="text" name="inputPass" id="inputPass" placeholder="Ingrese el password de acceso" 
                                    required class="inputText" autocomplete="off"
                                    oninput="this.value=value.replace(/[' ']/g,'')"/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>`,
            showDenyButton: true,
            denyButtonText: "Cancelar",
            denyButtonColor: "grey",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#04afaa",
            scrollbarPadding:false,
            allowOutsideClick:false,
            width:'500px',
            heightAuto: false,
            focusConfirm: false,
            showCloseButton:true,
            preConfirm: () => {
                if (document.getElementById('inputNombre').value) {//Se verifica que el campo nombre sea valido
                    if(document.getElementById('selectNivel').value 
                        && document.getElementById('selectNivel').value !== "0"){//Se verifica si el nivel de permiso es valido
                        if(document.getElementById('selectUH').value 
                            && document.getElementById('selectUH').value !== "0"){//Se verifica si la unidad hospitalaria es valida
                            if(document.getElementById('inputNick').value){//Se verifica si el user de acceso es valido
                                if(document.getElementById('inputPass').value){//Se verifica si el password de acceso es valido
                                    //Se solicita el registro de usuario
                                    solicitarCreateUser()
                                    async function solicitarCreateUser(){
                                        const response = await createUser(document.getElementById('selectNivel').value,
                                                document.getElementById('inputNombre').value.replace(/\s+/g, ' ').trim(),
                                                getUnidadHospitalariaObject(document.getElementById('selectUH').value,uhList),
                                                document.getElementById('inputPass').value,
                                                document.getElementById('inputNick').value)
                                        if(response === "success"){//Registro de usuario exitoso
                                            Swal.fire({
                                                icon: 'success',
                                                title: 'Registro de usuario',
                                                text: 'Usuario registrado de manera exitosa',
                                                confirmButtonText: "Aceptar",
                                                confirmButtonColor: "#04afaa",
                                              })
                                        }
                                        else{//Error en el registro de usuario
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Error',
                                                text: response,
                                              })
                                        }
                                    }
                                }
                                else{//Password de acceso invalido
                                    Swal.showValidationMessage('Proporcione el password de acceso del usuario')   
                                }
                            }
                            else{//User de acceso invalido
                                Swal.showValidationMessage('Proporcione el user de acceso del usuario')   
                            }
                        }
                        else{//Unidad Hospitalaria invalida
                            Swal.showValidationMessage('Proporcione la unidad hospitalaria')
                        }
                    }
                    else{//Nivel de acceso invalido
                        Swal.showValidationMessage('Proporcione el nivel de acceso') 
                    }
                 } else {//Nombre de usuario invalido
                   Swal.showValidationMessage('Proporcione el nombre del usuario')   
                 }
              }
        })
    }


    /**
     * Función que atrapa el evento de limpiar la búsqueda
     * @returns Devuelve el estado del objeto
     */
     const handleCancelarClick = () => (event) => {
        event.preventDefault()
        setValorBusqueda("")
    }

    const handleChange = (e) => {
        setUhSelectd(e.target.value)
      };

    return(
        <section className='seccion_pacientes_pendientes'>
            <div className='cuerpoEncabezado'>
            <EncabezadoSeccion tituloInicial={"Usuarios "} tituloFinal={"disponibles"} imgSource={"https://hospitalesmac.com/img/icono_16.png"}/>
            <div className='firstfiltercont'>
                <div className='ftconfliter'>
                    <div className="text-container">
                        <input type="text" 
                            name="valorBusqueda" 
                            value={valorBusqueda} 
                            className='inputbuscardirectorio' 
                            placeholder="Búsqueda abierta aquí..."
                            onChange={(event) => setValorBusqueda(event.target.value)}
                        />
                        {
                            seMuestra ? <span className='clearBtn' onClick={handleCancelarClick()}>X</span>
                            : null
                        } 
                    </div>
                    {
                            isMostrarUnidad
                                ?
                                    <div className="contenedor" id="contenedorHospital">
                                        <div className='unidad'>Unidad Hospitalaria</div>
                                        <select onChange={(e) => handleChange(e)}> 
                                            <option value={"General"}>{"General"}</option>
                                            {
                                                uhList.map(uh =>
                                                    <option value={uh.hospital}>{uh.hospital}</option>
                                                )
                                            }
                                        </select>
                                    </div>
                                :
                                    null
                    }
                </div>
            </div>
            </div>
            <div className='itemservespCont'>
                {
                    isLoader ?
                        <Loader/>
                    :
                    hayResultados ?
                        usersAmostrarList.map(user => 
                            <Usuario key={user.id} user={user} uhList={uhList} userLevel={userLevel} nomHospitalUser={nomHospital} isReadOnly={isReadOnly}/>
                        )
                    : <SinResultados/>
                }
                {/* <a href="#" className="btn_roundf" title="Agregar usuario" alt="Agregar" onClick={handleAgregar()}>+</a> */}
                {
                    !isReadOnly
                        ?
                            <button className="btn-flotante" title="Agregar usuario" alt="Agregar" onClick={handleAgregar()}>+ NUEVO USUARIO</button>
                        :
                            null
                }
                
            </div>
        </section>

    )
}

export default Usuarios